import { Box, Text } from "@chakra-ui/react";

const ACCENT = "#04aec1";

const AboutMission = () => (
  <Box
    as="section"
    bg="#ffffff"
    px={{ base: "20px", md: "28px" }}
    py={{ base: "64px", md: "96px" }}
  >
    <Box maxW="960px" mx="auto" textAlign="center">
      <Text
        as="span"
        display="inline-block"
        fontSize="11px"
        fontWeight={700}
        letterSpacing="0.16em"
        textTransform="uppercase"
        color={ACCENT}
        mb="18px"
      >
        Our mission
      </Text>
      <Text
        m={0}
        fontSize={{ base: "24px", md: "30px", lg: "36px" }}
        lineHeight="1.3"
        letterSpacing="-0.02em"
        fontWeight={600}
        color="#0a0e1a"
        sx={{ textWrap: "pretty" }}
      >
        Every retail brand should know — to the SKU, to the store, to the day —
        what's working and what's not. We exist to make that the default, not
        the privilege of the biggest players.
      </Text>
      <Text
        mt="32px"
        fontFamily="'Pinyon Script', 'Brush Script MT', cursive"
        fontSize={{ base: "36px", md: "48px" }}
        lineHeight="1"
        color={ACCENT}
      >
        — the Spear team
      </Text>
    </Box>
  </Box>
);

export default AboutMission;
